import React from 'react';
import {
  SelectField,
  MenuItem,
} from 'material-ui';
import ChipInput from 'material-ui-chip-input';
import {
  translate as t,
} from 'admin-on-rest';
import TextRecord from '../FormInputs/TextRecord';

export const SINGLE_SELECT_TYPE = 'multichoice';
export const defaultSingleSelect = () => {
  const randomInteger = Math.floor(Math.random() * 1000);
  const now = new Date().getTime();
  return {
    id: `${now}${randomInteger}`,
    type: SINGLE_SELECT_TYPE,
  };
};

const TRANSLATION_PREFIX = 'resources.quizes.fields.questions';
const TRANSLATION_QUIZ_PREFIX = 'resources.quizes.questions';

class SingleSelectForm extends React.Component {
  correctOnChange = (ev, key, payload) => {
    this.change('correct', payload);
  }

  addOption = (opt) => {
    const { options } = this.props;
    this.change('options', [...options, opt]);
  }

  removeOption = (removeOpt) => {
    const { options, correct, id } = this.props;
    const nextOptions = options.filter((opt) => opt !== removeOpt);
    if (nextOptions.indexOf(correct) > -1) {
      this.change('options', nextOptions);
    } else {
      // Make sure to unset "correct" if it disapeared from "options"
      this.props.onChange({
        correct: undefined,
        options: nextOptions,
      }, id);
    }
  }

  optionsOnChange = (opts) => {
    this.change('options', opts);
  }

  change = (key, value) => {
    const delta = {};
    delta[key] = value;
    this.props.onChange(delta, this.props.id);
  }

  render() {
    const {
      correct, options,
      translate,
    } = this.props;

    return (
      <>
        <TextRecord
          label={translate(`${TRANSLATION_PREFIX}.type`)}
          value={translate(`${TRANSLATION_QUIZ_PREFIX}.singleSelect`)}
        />
        <ChipInput
          value={options}
          floatingLabelText={translate(`${TRANSLATION_PREFIX}.options`)}
          // Some how this component needs all three of the below to work
          onChange={this.optionsOnChange}
          onRequestAdd={this.addOption}
          onRequestDelete={this.removeOption}
        />
        <br />
        <SelectField
          value={correct}
          floatingLabelText={translate(`${TRANSLATION_PREFIX}.correct`)}
          onChange={this.correctOnChange}
        >
          <MenuItem />
          {
            (options || []).map((opt) => (
              <MenuItem key={opt} value={opt} primaryText={opt} />
            ))
          }
        </SelectField>
      </>
    );
  }
}

export default t(SingleSelectForm);
